(() => {
  const closeAll = (except) => {
    document.querySelectorAll('[data-aura-sort].is-open').forEach((sort) => {
      if (sort !== except) {
        sort.classList.remove('is-open');
        const toggle = sort.querySelector('[data-aura-sort-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const goToSort = (value) => {
    const url = new URL(window.location.href);
    if (value) url.searchParams.set('sort_by', value);
    else url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    window.location.href = url.toString();
  };

  const clearCardLoading = () => {
    document.querySelectorAll('.aura-collection-card__action.is-loading').forEach((button) => {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    });
  };

  const showThemeNotification = (type, message, target) => {
    if (!message) return;
    if (window.MinimogTheme && MinimogTheme.Notification && typeof MinimogTheme.Notification.show === 'function') {
      MinimogTheme.Notification.show({
        target: target || document.body,
        method: 'appendChild',
        type,
        message,
        last: 2600,
        sticky: false,
      });
    }
  };

  const markUnavailable = (button) => {
    button.classList.remove('is-unavailable');
    void button.offsetWidth;
    button.classList.add('is-unavailable');
    const msg = (window.MinimogStrings && MinimogStrings.soldOut) || 'This product is currently unavailable';
    showThemeNotification('warning', msg);
    setTimeout(() => button.classList.remove('is-unavailable'), 650);
  };

  const getCartAddUrl = () => {
    if (window.MinimogSettings && MinimogSettings.routes && MinimogSettings.routes.cart_add_url) {
      return MinimogSettings.routes.cart_add_url;
    }
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return `${Shopify.routes.root}cart/add.js`;
    }
    return '/cart/add.js';
  };

  const buildCartFormData = (form) => {
    const formData = new FormData(form);

    let sectionsToBundle = [];
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
    } catch (error) {
      sectionsToBundle = [];
    }

    if (sectionsToBundle.length) {
      formData.append('sections', sectionsToBundle);
      formData.append('sections_url', window.location.pathname);
    }

    return formData;
  };

  const openCartDrawer = (response, formData) => {
    const cartDrawer = document.querySelector('m-cart-drawer');

    if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
      window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
        cart: response,
        productVariantId: formData.get('id'),
      });
    }

    if (cartDrawer && window.MinimogSettings && MinimogSettings.enable_cart_drawer) {
      if (window.MinimogTheme && MinimogTheme.Notification && typeof MinimogTheme.Notification.show === 'function') {
        const target = cartDrawer.querySelector('m-cart-items') || cartDrawer;
        MinimogTheme.Notification.show({
          target,
          method: 'prepend',
          type: 'success',
          message: (window.MinimogStrings && MinimogStrings.itemAdded) || 'Added to cart',
          delay: 250,
        });
      }

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents && MinimogTheme.pubSubEvents.openCartDrawer) {
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
      }
    } else {
      showThemeNotification('success', (window.MinimogStrings && MinimogStrings.itemAdded) || 'Added to cart');
    }

    document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: response } }));
  };

  const addToCart = async (form) => {
    const button = form.querySelector('[data-aura-add-button], button[type="submit"]');
    if (!button || button.classList.contains('is-loading')) return;

    const isAvailable = button.dataset.auraProductAvailable !== 'false' && button.getAttribute('aria-disabled') !== 'true';
    if (!isAvailable) {
      markUnavailable(button);
      return;
    }

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const formData = buildCartFormData(form);

      const config = window.fetchConfig ? fetchConfig('javascript') : {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      };

      config.method = 'POST';
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch(getCartAddUrl(), config);
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data && (data.description || data.message || data.error) ? (data.description || data.message || data.error) : 'Unable to add item');
      }

      button.classList.remove('is-loading');
      button.classList.add('is-added');

      openCartDrawer(data, formData);

      setTimeout(() => button.classList.remove('is-added'), 1100);
    } catch (error) {
      console.error(error);
      button.classList.remove('is-loading');
      showThemeNotification('error', error.message || 'Unable to add item');
    } finally {
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-aura-sort-toggle]');
    if (toggle) {
      event.preventDefault();
      const sort = toggle.closest('[data-aura-sort]');
      const willOpen = !sort.classList.contains('is-open');
      closeAll(sort);
      sort.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    const option = event.target.closest('[data-aura-sort-value]');
    if (option) {
      event.preventDefault();
      const value = option.getAttribute('data-aura-sort-value');
      closeAll();
      goToSort(value);
      return;
    }

    const addButton = event.target.closest('[data-aura-add-button]');
    if (addButton) {
      event.preventDefault();
      event.stopPropagation();
      const form = addButton.closest('[data-aura-collection-add-form]');
      if (form) addToCart(form);
      return;
    }

    const quickViewButton = event.target.closest('.aura-collection-card__action.m-product-quickview-button');
    if (quickViewButton) {
      quickViewButton.classList.add('is-loading');
      quickViewButton.setAttribute('aria-busy', 'true');
      window.setTimeout(() => {
        quickViewButton.classList.remove('is-loading');
        quickViewButton.removeAttribute('aria-busy');
      }, 5000);
      return;
    }

    if (!event.target.closest('[data-aura-sort]')) closeAll();
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-aura-collection-add-form]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    addToCart(form);
  }, true);

  document.addEventListener('quick-view:loaded', clearCardLoading);
  document.addEventListener('product-ajax:added', clearCardLoading);

  if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, clearCardLoading);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();

